import { useRecoilState } from "recoil";
import myInfoState from "../../atoms/myinfo";
import waitingRoomState, { RoomsSortingType } from "../../atoms/waiting-room";
import "./WaitingRoomHeader.scoped.scss"

function WaitingRoomHeader() {
  const [myInfo] = useRecoilState(myInfoState);
  const [waitingRoom, setWaitingRoom] = useRecoilState(waitingRoomState);

  const enterMyRoom = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      window.alert('로그인 후 이용해주세요.');
      return;
    }
    if (myInfo.ownRoomId === '' || myInfo.ownRoomId == null) {
      window.alert('생성된 방이 없습니다.');
      return;
    }
    window.location.href = `/chatting-app/room/${myInfo.ownRoomId}`;
  }

  const openCreatingRoomModal = () => {
    if (myInfo.userDetail == null || myInfo.userDetail.id === '') {
      window.alert('로그인 후 이용해주세요.');
      return;
    }
    if (myInfo.ownRoomId !== '' && myInfo.ownRoomId != null) {
      window.alert('이미 생성한 방이 있습니다.');
      return;
    }
    setWaitingRoom({
      ...waitingRoom,
      isOpenedCreatingRoom: true,
    })
  }

  return (
    <div className="waiting-room-header">
      <b className="waiting-room-header__title">채팅 대기실</b>
      <div className="waiting-room-header__sort">
        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_PARTICIPANTS ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_PARTICIPANTS })}
        >
          참여자순
        </button>
        <button 
          className={`waiting-room-header__sort-button ${waitingRoom.roomsSorting === RoomsSortingType.SORT_IN_NEWER ? 'sort-button--active' : ''}`}
          onClick={() => setWaitingRoom({ ...waitingRoom, roomsSorting: RoomsSortingType.SORT_IN_NEWER })}
        >
          최신순
        </button>
      </div>
      <div>
        <button
          className="waiting-room-header__entering-my-room-button"
          onClick={enterMyRoom}
        >
          나의 채팅방 입장하기
        </button>
        <button 
          className="waiting-room-header__creating-room-button"
          onClick={openCreatingRoomModal}
        >
          채팅방 개설하기
        </button>
      </div>
    </div>
  );
}

export default WaitingRoomHeader;
